import axios from "axios";
import { useState, useContext } from "react";
import Logged from "../Components/Profile.jsx";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import { url } from "../utils/url";
import { LoadingOutlined } from "@ant-design/icons";
import SEO from "../Components/SEO";
import SidebarNav from "../Components/navigation/SidebarNav.jsx";

const ReportIssue = () => {
  const { user } = useContext(UserContext);
  const [names, setnames] = useState();
  const [content, setcontent] = useState("");
  const [isSent, setisSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlenames = (e) => {
    setnames(e.target.value);
  };
  const handlecontent = (e) => {
    setcontent(e.target.value);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const report = {
      user_id: user.info?._id,
      names,
      content,
    };
    await axios
      .post(`${url}/api/issues/addissue`, report, {})
      .then((res) => {
        setisSent(true);
      })
      .catch((err) => {
        window.displayToastError("Report not sent");
        setLoading(false);
      });
    setLoading(false);
  }
  return (
    <>
      <SEO title={`Report Issue`}></SEO>
      <div className="flex justify-center w-full">
        <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
          <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
                <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
              <form className="w-full " onSubmit={handleSubmit}>
                {isSent ? (
                  <div>Thanks For Sending this report to us.</div>
                ) : (
                  <div>
                    <h1 className="text-sm font-bold mt-5 mb-3">
                      {" "}
                      Report Issue
                    </h1>
                    <div className="form-group">
                      <label htmlFor="reportnames">Names</label>
                      <input
                        type="text"
                        className="form-control"
                        id="reportnames"
                        defaultValue={user.info?.names}
                        value={names}
                        onChange={handlenames}
                        placeholder=""
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="reportcontent">Content</label>
                      <textarea
                        className="form-control"
                        id="reportcontent"
                        value={content}
                        onChange={handlecontent}
                        placeholder=""
                        rows="6"
                        required
                      />
                    </div>
                    {!loading ? (
                      <button
                        type="submit"
                        className="btn bg-fire upda-btn text-white hover:opacity-50 hover:text-white"
                      >
                        Send Report
                      </button>
                    ) : (
                      <button
                        className="btn bg-fire upda-btn opacity-50 text-white flex gap-4 items-center"
                        disabled
                      >
                        <LoadingOutlined />
                        <span> Sending ...</span>
                      </button>
                    )}
                  </div>
                )}
              </form>
            </div>
            </div>
            <div className="lg:col-span-5">
              {user.token ? <Logged /> : <TryLogin />}
            </div>
          </div>
      
      </div>
      
    </>
  );
};
export default ReportIssue;
